import React, { ReactNode } from 'react';
import { childrenIdMatch } from '../utils';

export const findChildByType = (children: ReactNode, id: string) =>
    React.Children.toArray(children).find((child) => childrenIdMatch(child, id));
